import { Answer, AnswerState } from "@domain/Answer";

export class AnswerFactory {
  static createSubmittedAnswer(answer: Answer, isAnswerCorrect: boolean) {
    const answerState = isAnswerCorrect ? AnswerState.CORRECT : AnswerState.INCORRECT;

    return new Answer({
      value: answer.value,
      state: answerState,
    });
  }

  static createNewAnswer(answer: string) {
    return new Answer({
      value: answer,
      state: AnswerState.NOT_SUBMITTED,
    });
  }
}
